<style  scoped>



</style>

<template>

  <div class="c-page u-relative" ref="careersection1">

      <section    data-color="clear" class="u-relative u-fit-w  u-overflow-h js-header-panel">
          <div class="c-page__header o-wrapper--panel" :style="myStylesTransform2">
            <img  :src="imageHeadSrc" class="u-absolute u-pos-tl"  :style="myStylesWidthHeight">
          </div>
          <div class="o-wrapper--valign u-viewport-fit-h u-fit-w">
              <div class="u-relative u-inline-block u-valign-bottom u-marg-l-w1of12 u-marg-b-vh1of12 u-marg-b-vh3of12@sm">
                <span class="c-page__subtitle t-h2 t-text--roman u-color--white u-inline-block u-marg-b-md" >Careers</span>
                  <h1 class="t-h2-sub  t-text-lh--md u-color--white u-marg-b-lg">
                      <app-sliced-text :content="'Realize your passions. </br> Join our team of natural </br>visionaries and entrepreneurs.'"></app-sliced-text>
                  </h1>
                </div>
          </div>
      </section>
      <section data-color="dark" class="u-relative u-fit-w  u-overflow-h js-header-panel">


   <div class="u-relative u-fit-w">


      <div class="u-flex u-flex-fd--column@sm  u-align-left  u-pad-x-w2of12">


        <div class="c-page c-blog  u-pad-x-w1of12@sm  u-fit-w"  >
           <header  >
             <h3 class="t-h3 u-marg-t-xxl  t-text--roman u-relative u-marg-r-lg u-marg-b-lgs u-marg-r-0@smu-color--gray u-color--gray"  ref="article">
                 <img src="../../assets/medias/images/lgoRghPart.svg" class="c-logo-Sector-offset2 c-investors__section-2__pattern c-firstslide__whoweare__logo  u-absolute u-pos-bl">
                  <span class="c-number-offset2 t-text--xl--Light u-absolute u-pos-bl"  >01</span>
                  <app-sliced-text :content="'Resource Group Job Opportunities'"></app-sliced-text>
              </h3>
             <div class="u-flex u-flex-fd--row  u-flex__item-as--start u-fit-w  u-marg-b-lgs u-hide@md">
               <div class="u-w12of10">&nbsp;</div>
               <div class="u-w2of5 u-w1of2@md careers-u-color--brand-bold-Title">Title</div>
               <div class="u-w4of50 u-hide@sm u-marg-r-xs careers-u-color--brand-bold-Title">Company</div>
               <div class="u-w4of50 u-hide@md u-marg-r-xs careers-u-color--brand-bold-Title">Location</div>
               <div class="u-w4of50  u-marg-r-xs careers-u-color--brand-bold-Title">Posted On</div>
               <div class="u-w1of10  u-marg-r-xs">&nbsp;</div>
               <div class="u-w1of10  u-marg-r-xs">&nbsp;</div>
              </div>
         </header>
         
         <div class="u-flex u-flex-fd--row  u-pad-y-sm   u-flex-fd--column@md  u-flex__item-as--start u-fit-w c-blog__careers u-pad-x-w0of0@xs u-w2of10"   v-if="areTherePosts"  v-for="(post,index)  in posts"   :key="post.id"   >
           <div class="u-w12of10 career-number-index u-hide@md u-color--gray--CarrerNumbering">{{post.IndexLevel+1<10?"0"+(post.IndexLevel+1):post.IndexLevel+1}}.</div>
           <div class="u-w2of5 u-pad-y-sm@md  u-w2of2@md careers-u-color--brand"><span class="u-hide-min@md careers-u-color--brand-bold-Title">Title: </span>{{post.title}}</div>
           <div class="u-w4of50 u-pad-y-sm@md  u-w2of2@md  u-marg-r-xs careers-u-color--brand"><span class="u-hide-min@md careers-u-color--brand-bold-Title">Company: </span>{{post.Company}}</div>
           <div class="u-w4of50 u-pad-y-sm@md  u-w2of2@md u-marg-r-xs careers-u-color--brand"><span class="u-hide-min@md careers-u-color--brand-bold-Title">Location: </span>{{post.Location}}</div>
           <div class="u-w4of50 u-pad-y-sm@md u-marg-r-xs u-w2of2@md careers-u-color--brand"><span class="u-hide-min@md careers-u-color--brand-bold-Title">Posted On: </span>{{post.PostedOn}}</div>
           <div class="u-w1of10 u-pad-y-sm@md  u-marg-r-xs u-w2of2@md " ><a href="javascript:void(0);"  @click="scrollMeToApply(post.title,post.Company)"  class="u-color--gray t-text--base-bold">Apply</a></div>
           <div class="u-w1of10  u-marg-r-xs u-w2of2@md"><a :href="filesRoot+post.Url" target="_blank"><img src="../../assets/medias/images/icons/downloadpdf.png"/></a></div>
          </div>




         <div class="c-blog__article u-flex u-flex-fd--column@sm u-pad-y-xl" v-if="!areTherePosts">
           <div class="u-fit-w">
               <h2 class="t-h5 t-text--roman u-marg-b-md">{{posts[0].title}}</h2>
           </div>
         </div>
           <!---->
           <footer class="c-blog__footer u-pad-t-md u-pad-b-xxl">
              <div class="c-blog__footer__prev u-w2of10 u-uppercase">
                    <router-link v-if="currentPageIndex > 1 && 0 !== currentPageIndex" class="c-blog__footer__prev__link u-relative u-color--gray" :to="'/resourcegroup/en/careers-job-opportunities-vacancies-lebanon?page='+(currentPageIndex - 1)">
                       Prev
                    </router-link>
               </div>
              <div class="c-blog__footer__pagination u-w6of10">
                        <router-link v-if="currentPageIndex>3" :to="'/resourcegroup/en/careers-job-opportunities-vacancies-lebanon?page=1'+pages[0].index" class="c-blog__footer__pagination__page u-relative u-color--gray" :class="'c-blog__footer__pagination__page--'+pages[0].index">
                       {{"0"+(pages[0].index)}}
                       </router-link>
                       <div v-if="currentPageIndex>4"  class="c-blog__footer__pagination__page" >
                         ...
                      </div>
                      <router-link v-if="indexp <= currentPageIndex + 1 && indexp >= currentPageIndex || indexp >= currentPageIndex - 3 && indexp <= currentPageIndex"  v-for="(page, indexp)  in pages" :key="page.id" class="c-blog__footer__pagination__page u-relative u-color--gray" :class="[{'is-active':page.index===currentPageIndex},'c-blog__footer__pagination__page--'+indexp]" :to="'/resourcegroup/en/careers-job-opportunities-vacancies-lebanon?page='+ page.index">
                        {{page.index<10?"0"+page.index:page.index}}
                      </router-link>
                      <div  v-if="currentPageIndex<pages.length-3"   class="c-blog__footer__pagination__page">
                        ...
                      </div>

                      <router-link v-if="currentPageIndex < pages.length-2"  class="c-blog__footer__next__link u-relative u-color--gray" :class="['c-blog__footer__pagination__page--'+pages[pages.length-1].index]" :to="'/resourcegroup/en/careers-job-opportunities-vacancies-lebanon?page='+ pages[pages.length-1].index">
                       {{pages[pages.length-1].index<10?"0"+pages[pages.length-1].index:pages[pages.length-1].index}}
                      </router-link>
            </div>
              <div class="c-blog__footer__next u-w2of10 u-uppercase">
              <router-link v-if="currentPageIndex < pages.length && 0 !== currentPageIndex"  class="c-blog__footer__next__link u-relative u-color--gray"  :to="'/resourcegroup/en/careers-job-opportunities-vacancies-lebanon?page='+ (currentPageIndex + 1)">
               Next
              </router-link>
            </div>
            </footer>
        </div>
  </div>
 </div>
</section>
  <app-footer :globalContent="globalContent" :adminContent="adminContent"  :newsletterShown="!1" :careersShown="!0"></app-footer>
  </div>

</template>

<script>
import {format, compareAsc} from 'date-fns'
import AppFooter from  '../app-footer/index.vue'
import  AppSlicedText from '../app-sliced-text/index.vue'
import {getAbsoluteBoundingRect}  from '../../utilities/getAbsoluteBoundingRect.js'
export default
{
          components:{
                                    "app-sliced-text":AppSlicedText,
                                    "app-footer":AppFooter
                    },
                  props: {
                      adminContent: {
                          type: Object,
                          default: function() {}
                      },
                      globalContent: {
                          type: Object,
                          default: function() {}
                      },
                      headerPageSize: {
                          type: Array,
                          default: function() {}
                      }
                  },
                  data: function() {
                      return {
                          areTherePosts: !1,
                            imageHeadSrc:require('../../assets/medias/images/Header-carrers-RGH.jpg')
                      }

                  },
                  computed:
                  {
                      computedPosts: function()
                      {
                          var t = [];
                          if (this.$route.query.page)
                          {

                              if (Object.keys(this.adminContent.en.posts_carrer_page).length > 0)
                              {
                                  if (this.adminContent.en.posts_carrer_page[this.$route.query.page])
                                  {
                                      this.areTherePosts = !0;
                                      var blockIndex=(parseInt(this.$route.query.page)-1)*4;

                                      for (var e = 0, n = this.adminContent.en.posts_carrer_page[this.$route.query.page].length; e < n; e += 1)
                                      {

                                          var r = this.adminContent.en.posts_carrer_page[this.$route.query.page][e];
                                          r.IndexLevel=blockIndex+e;
                                          r.dateFormated = {
                                              //day: format(r.post_wp.post_date, "DD"),
                                            //  month: format(r.post_wp.post_date, "MMMM"),
                                            //  year: format(r.post_wp.post_date, "YY")
                                          },
                                           t.push(r)
                                      }
                                  }
                                  else
                                  {
                                   this.areTherePosts = !1,
                                   t.push({
                                      title: "Error - Page not found",
                                      first_paragraph_shorted: "Incorrect page number. <br /> Please click on one of the page numbers below.",
                                      dateFormated: {
                                          day: 404,
                                          month: "",
                                          year: ""
                                      }
                                  })
                                }
                              }
                          }
                          else
                          {
                          this.areTherePosts = !1, t.push({
                              title: "No recents announcements yet.",
                              first_paragraph_shorted: "",
                              dateFormated: {
                                  day: "",
                                  month: "",
                                  year: ""
                              }
                          })
                        }
                          return t
                      },
                      computedPages: function()
                      {
                          var t = [];
                          if (this.$route.query.page)
                          {
                              t.length = 0;
                              for (var e = 0, n = Object.keys(this.adminContent.en.posts_carrer_page).length; e < n; e += 1)
                              {
                                  var r = Object.keys(this.adminContent.en.posts_carrer_page)[e];
                                  t.push({
                                      index: parseInt(r, 10),
                                      isVisible: !0
                                  })
                              }
                          }
                          return t
                      },
                      computedCurrentPageIndex: function()
                      {
                          var t = 1;
                          return this.$route.query.page && (t = this.adminContent.en.posts_carrer_page[this.$route.query.page] ? parseInt(this.$route.query.page, 10) : 0), t
                      }

                      ,
                      myStylesTransform2() {
                        return {
                            transform: 'translateX('+this.headerPageSize[2]+'px) translateY('+this.headerPageSize[3]+'px) scale('+this.headerPageSize[4]+')'

                        }

                    },
                    myStylesWidthHeight() {
                       return {
                         width: this.headerPageSize[0] + "px",
                         height: this.headerPageSize[1] + "px"

                       }
                   }

                  },
                  beforeCreate: function()
                  {
                      this.$route.query.page || this.$router.push("/resourcegroup/en/careers-job-opportunities-vacancies-lebanon?page=1")
                  },
                  created: function()
                  {
                      this.adminContent.en.pages.blog.blog_is_active ? this.$route.query.page || this.$router.replace("/resourcegroup/en/careers-job-opportunities-vacancies-lebanon?page=1") : this.$router.replace("/404"),
                      this.filesRoot= this.adminContent.en.pages.blog.root, 
                      this.onResize = this.onResize.bind(this),
                      this.posts = this.computedPosts,
                      this.pages = this.computedPages,
                      this.currentPageIndex = this.computedCurrentPageIndex,
                      this.eventHub.$on("resize", this.onResize)
                  },
                  destroyed: function()
                  {
                      this.eventHub.$off("resize", this.onResize)
                  },
                  mounted: function()
                  {
                      this.eventHub.$emit("page:ready"),
                      this.scrollMeTo('article'),
                      this.onResize()
                  },
                  methods:
                  {
                      onResize: function() {},
                      scrollMeTo(refName) {
                                var element = this.$refs[refName];
                                var _offsetY=(0,getAbsoluteBoundingRect)(element).top;
                                var _fullOffsetY = element.offsetHeight + _offsetY-150;
                                if(this.$route.query.load!=1)
                                  window.scrollTo(0, _fullOffsetY);
                                },
                                scrollMeToApply(p,t) {
                                          this.eventHub.$emit("footer:applyto",p,t)
                  }

                  }
    }

</script>



// WEBPACK FOOTER //
// src/components/app-page-carrers/index.vue